export default __webpack_public_path__ + "static/media/Scholarships and Awards Summit Logo.72d8cc15.png";